import { i18n } from 'src/boot/i18n'

class ActionPlanEvent {
  constructor (_event) {
    if (_event !== undefined) {
      this.attributes = {
        id: _event.id ? _event.id : null,
        title: _event.title ? _event.title : null,
        summary: _event.action_plan_name ? _event.action_plan_name : null,
        type: 'action_plan',
        event_type: 'action_plan',
        type_name: i18n.global.t('tasks.task'),
        location: _event.location_name ? {
          id: _event.location_id,
          name: _event.location_name,
          address: _event.location_address
        } : null,
        start_date: _event.end_date ? _event.end_date : null,
        end_date: _event.end_date ? _event.end_date : null,
        start: {
          date: _event.end_date ? _event.end_date.slice(0, 10) : null
        },
        end: {
          date: _event.end_date ? _event.end_date.slice(0, 10) : null
        },
        notes: _event.notes ? _event.notes : '',
        assigned_to: _event.assigned_to ? _event.assigned_to : null,
        created_by: _event.created_by ? _event.created_by : null,
        event_id: _event.routine_event_id ? _event.routine_event_id : null,
        routineName: _event.routine_name ? _event.routine_name : null,
        sprint_plan_id: _event.sprint_plan_id ? _event.sprint_plan_id : null,
        sprintName: _event.sprint_name ? _event.sprint_name : null,
        value: _event.value ? _event.value : null,
        icon: 'task',
        answerDate: _event.answer_date ? _event.answer_date : null,
        reviewStatus: _event.review_status ? _event.review_status : null,
        triggeredBy: _event.assigned_to ? _event.assigned_to : null
      }
    } else {
      this.attributes = {
        id: null,
        date: null,
        name: null,
        end_date: null,
        type: 'action_plan',
        event_type: 'action_plan',
        notes: '',
        created_by: null,
        assigned_to: null,
        event_id: null,
        sprint_plan_id: null,
        sprintName: null,
        value: null,
        icon: 'task',
        answerDate: null,
        reviewStatus: null,
        triggeredBy: null
      }
    }
  }
}

export default ActionPlanEvent
